import alt from "../alt";
import indexBy from "lodash/keyBy";
import extend from "lodash/extend";
import values from "lodash/values";
import ItemUtil from "../utils/ItemUtil";
import ItemActions from "../actions/ItemActions";
import UserStore from "../stores/UserStore";

class ItemStore {
  constructor() {
    this.bindActions(ItemActions);

    this.state = {
      items: {},
      isFetching: false
    };

    this.exportPublicMethods({
      getItemById: this.getItemById.bind(this),
      getItemsForPerson: this.getItemsForPerson.bind(this),
      getItemsForItemBucket: this.getItemsForItemBucket.bind(this)
    });
  }

  getItemById(id) {
    return this.state.items[id];
  }

  getItemsForPerson(id, eventBucket) {
    return values(this.state.items).filter(function(i) {
      if (eventBucket && i.event_bucket !== eventBucket) {
        return false;
      }
      return i.person && i.person.id === id;
    });
  }

  getItemsForItemBucket(id) {
    return values(this.state.items).filter(function(i) {
      return i.item_bucket.id === id;
    });
  }

  onFetchAllForItemBucket(itemBucketId) {
    this.setState({ isFetching: true });
    ItemUtil.fetchAllForItemBucket(UserStore.getState().apiKey, itemBucketId)
      .then(data => {
        this.setState({ isFetching: false });
        ItemActions.updateItems(indexBy(data, "id"));
      })
      .catch(ItemActions.fetchFailed);
  }

  onFetchAllForPerson(personId) {
    this.setState({ isFetching: true });
    ItemUtil.fetchAllForPerson(UserStore.getState().apiKey, personId)
      .then(data => {
        this.setState({ isFetching: false });
        ItemActions.updateItems(indexBy(data, "id"));
      })
      .catch(ItemActions.fetchFailed);
  }

  onFetchOne(id) {
    this.setState({ isFetching: true });
    ItemUtil.fetchOne(UserStore.getState().apiKey, id)
      .then(data => {
        this.setState({ isFetching: false });
        ItemActions.updateItem(id, data);
      })
      .catch(ItemActions.fetchFailed);
  }

  onDelete(id) {
    ItemUtil.delete(UserStore.getState().apiKey, id).then(data => {
      delete this.state.items[id];
      this.setState(this.state);
    });
  }

  onUpdateItem(data) {
    this.state.items[data.id] = data.item;
    this.setState(this.state);
  }

  onUpdateItems(items) {
    extend(this.state.items, items);
    this.setState(this.state);
  }

  onFetchFailed(e) {
    this.setState({ isFetching: false });
    alert(`Fetching item failed: ${e.message}`);
    throw e;
  }
}

export default alt.createStore(ItemStore, "ItemStore");



// WEBPACK FOOTER //
// ./src/app/stores/ItemStore.js